export enum DataStore {
	PLAGUE_CATALOG = "plagues_catalog",
	IMAGE = "image",
    CULTURE = "culture",
    FARM = "farm",
    ENVIRONMENT = "environment",
    AGRICULTURAL_YEAR = "agricultural_year",
    VARIETY = "variety",
    ENVIRONMENT_PLAGUE_PHOTO = "environment_plague_photo",
    INSPECTION = "inspection",
    VARIABLE = "variable",
    VARIABLE_POINT = "variable_point",
    VARIABLE_PLAGUE = "variable_plague"
}

export function isDataStoreAutoincrement(dataStore: DataStore): boolean {
	let storesAutoincrement = [];
	return storesAutoincrement.filter(store => store == dataStore).length > 0;
}